export default __webpack_public_path__ + "static/media/addLocation.bf8f390b.svg";